import { ChipProps } from '@msc-b2c/interfaces/types';
import { Icon } from '../icons/Icon';
import clsx from 'clsx';
import './chip.module.scss';

export const Chip = ({
  id,
  text,
  icon,
  isBadge = false,
  onClick,
  styleOption = '',
  ribbonTextColor,
  ribbonBGColor,
  filterType,
  isIconOnTheLeft = false,
}: ChipProps) => {
  const isFocusable = !isBadge;

  return (
    text && (
      <div
        id={id}
        className={clsx(styleOption, isBadge ? '-badge' : '')}
        aria-label={isFocusable ? text : undefined}
        data-filter-type={filterType}
      >
        <div
          className={clsx('cmp-chip', {
            '-badge': isBadge && !onClick,
            'icon-on-left': isIconOnTheLeft,
          })}
          style={
            ribbonBGColor && ribbonTextColor
              ? { backgroundColor: ribbonBGColor, color: ribbonTextColor }
              : {}
          }
        >
          <span>{text}</span>
          {!!icon && (
            <Icon
              icon={icon}
              onClick={onClick}
              ariaLabel="Remove filter"
            />
          )}
        </div>
      </div>
    )
  );
};
